import { ReactElement, useContext, useState } from "react";
import { ButtonMenu } from "../ButtonMenu";
import { Agrup, ButtonRotina, Icon, Organize, Seta, SubAgrup } from "../style";
import { AuthContext, Rotina } from "../../../context/Auth";
import seta from "../../../assets/img/seta.svg";
import home from "../../../assets/img/Home.svg";
import { useLocation } from "react-router-dom";

export const MenuCrm = (): ReactElement | null => {

  const { usuarioRotinas } = useContext<any>(AuthContext);

  const { pathname } = useLocation();

  const [crmclick, setClickCrm] = useState<boolean>(false);

  const menus = usuarioRotinas.map((rotina: Rotina) => rotina.nomemenu);
  const rotinas = usuarioRotinas.map((rotina: Rotina) => rotina.nomerotina);

  return (
    <>
      {
        menus.some((menu: string) => menu == "CRM") ?
          <ButtonRotina onClick={() => { setClickCrm(!crmclick); }}>
            <Organize active={pathname?.match('crm')}>
              <Agrup>
                <Icon src={home} alt="crm" />
                <p>CRM</p>
              </Agrup>
              <Seta src={seta} active={crmclick} />
            </Organize>

            {
              crmclick ?

                <SubAgrup onClick={(event) => event?.stopPropagation()}>
                  {
                    rotinas.some((rotina: string) => rotina == "Dashboard CRM") ?
                      <ButtonMenu direcao="/dash/crm/dash" nomeEstilo="subitem" titulo="Dashboard CRM" />
                      : false
                  }
                  {
                    rotinas.some((rotina: string) => rotina == "Lista de Membros") ?
                      <ButtonMenu direcao="/dash/crm/membros" nomeEstilo="subitem" titulo="Membros Cadastrados" />
                      : false
                  }
                </SubAgrup>

                : false
            }

          </ButtonRotina>
          : false
      }
    </>
  )
}
